module.exports = __webpack_public_path__ + "img/Carousel-4.544a56f7.png";